import { Tabs, Box, Tab } from "@mui/material";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

import Colors from "../../../../../global/Colors";

const DEFAULT_SX = {
  "& button.Mui-selected": {
    color: Colors.purple[600],
    backgroundColor: Colors.white,
    borderRadius: "10px 10px 0 0",
    border: `1px solid ${Colors.slate[300]}`,
    borderBottom: `none`,
  },
  "& .Mui-selected": {
    color: Colors.purple[600],
    backgroundColor: Colors.white,
    borderRadius: "10px 10px 0 0",
  },
  "& .MuiTab-root": {
    borderBottom: `1px solid ${Colors.slate[300]}`,
    fontWeight: "700",
  },
  "& .MuiBox-root.div": {
    padding: 0,
    color: Colors.black,
  },
  "& .MuiTab-textColorPrimary": {
    color: Colors.black,
  },
  "& .Mui-disabled": {
    color: Colors.gray[400],
  },
};

export default function TabHeader({
  tabList,
  tabValue,
  boxBackgroundColor = Colors.gray[100],
  tabVariant = "fullWidth",
  tabIndicatorSx = { backgroundColor: "transparent" },
  tabsSx = DEFAULT_SX,
}) {
  const navigate = useNavigate();

  const handleChange = (_, newValue) => {
    navigate(tabList[newValue].href);
  };

  return (
    <Box className="bg-transparent" sx={{ backgroundColor: boxBackgroundColor }}>
      <Tabs
        value={tabValue}
        onChange={handleChange}
        className="font-bold"
        variant={tabVariant}
        TabIndicatorProps={{ sx: tabIndicatorSx }}
        sx={{ ...tabsSx }}
      >
        {tabList.map((tab, index) => {
          return tab.permission === null || (tab.permission !== null && tab.permission) ? (
            <Tab
              key={tab.id + "_" + index}
              label={tab.name}
              value={index}
              disabled={tab.isDisabled}
            />
          ) : null;
        })}
      </Tabs>
    </Box>
  );
}

TabHeader.propTypes = {
  tabList: PropTypes.array,
  tabValue: PropTypes.number,
  handleChange: PropTypes.func,
  boxBackgroundColor: PropTypes.string,
  tabVariant: PropTypes.string,
  tabIndicatorSx: PropTypes.object,
  tabsSx: PropTypes.object,
};
